export default __webpack_public_path__ + "static/media/Grad cap.57c101a9.svg";